/**
 * MSAL config for Entra OAuth (PKCE-based public client).
 *
 * PIVOT-POINT: when the IdP broker (WorkOS / Entra External ID / etc.)
 * arrives, the values here change — authority URL points at the broker,
 * scopes may change shape. The structure stays. Treat this file as the
 * single isolation point for IdP-specific config.
 */
import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

const tenantId = import.meta.env['VITE_AZURE_TENANT_ID'] as string;
const clientId = import.meta.env['VITE_AZURE_CLIENT_ID'] as string;
const apiScope = import.meta.env['VITE_API_SCOPE'] as string;

if (!tenantId || !clientId || !apiScope) {
  throw new Error(
    'Missing required MSAL env vars: VITE_AZURE_TENANT_ID, VITE_AZURE_CLIENT_ID, VITE_API_SCOPE',
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // Shared by every tab. MSAL encrypts it with a key kept in a cookie that ends when the browser closes.
    cacheLocation: 'localStorage',
  },
};

export const apiTokenRequest = {
  scopes: [apiScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);
